import React from 'react';
import { PropTypes } from 'prop-types';
import Button from '@atoms/Button';
import { H2, H4 } from '@styled';

const HeroWithCTA = ({ text, textColor = '#fff', overlayColor, subtext, ctaText, ctaAction, imageSrc }) => (
    <div
        className="d-flex flex-column justify-content-center text-center relative"
        style={{
            backgroundPosition: 'center center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            backgroundImage: `url('${imageSrc}')`,
        }}
    >
        {overlayColor && (
            <div
                style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    zIndex: '0',
                    backgroundColor: overlayColor,
                    mixBlendMode: 'multiply',
                }}
            />
        )}

        <div style={{ padding: 'calc(1rem + 3vw)' }} className="container">
            <H2 className="mb-3" style={{ fontSize: 'calc(1.1rem + 1.4vw)', lineHeight: '1.3', color: textColor }}>
                {text}
            </H2>

            {subtext && (
                <H4 className="mt-1rem" style={{ color: textColor }}>
                    {subtext}
                </H4>
            )}
            {ctaText && (
                <Button
                    onClick={() => {
                        if (ctaAction) {
                            ctaAction();
                        }
                    }}
                >
                    {ctaText}
                </Button>
            )}
        </div>
    </div>
);

HeroWithCTA.propTypes = {
    text: PropTypes.string.isRequired,
    textColor: PropTypes.string,
    overlayColor: PropTypes.string,
    subtext: PropTypes.string,
    ctaText: PropTypes.string,
    ctaAction: PropTypes.func,
    imageSrc: PropTypes.string,
};

export default HeroWithCTA;
